var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('BaseCardContainer',{attrs:{"title":"Modifier le document","noFooter":""}},[_c('DocumentForm',{attrs:{"id":"form","data":_vm.document},on:{"onSubmit":_vm.onSubmit,"onCancel":_vm.onCancel}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }